import { render, staticRenderFns } from "./EditProviderCategoryModal.vue?vue&type=template&id=63079ece"
import script from "./EditProviderCategoryModal.vue?vue&type=script&lang=js"
export * from "./EditProviderCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports